import CheckCircleOutline from "@/assets/icons/check-circle-outline.svg?react";
import CheckCircleSolid from "@/assets/icons/check-circle-solid.svg?react";
import { cn } from "@/lib/utils";
import { EditionMilestone } from "@/types/edition";
import { parseISO } from "date-fns";
import { format } from "date-fns/format";
import { FC } from "react";

type MilestonesDropdownItemProps = {
  milestone: EditionMilestone;
};

const MilestonesDropdownItem: FC<MilestonesDropdownItemProps> = ({
  milestone,
}) => {
  const startDate = format(parseISO(milestone.startDate), "dd MMM yyyy");

  const endDate = format(parseISO(milestone.endDate), "dd MMM yyyy");

  return (
    <div
      className={cn(
        "group relative flex flex-row gap-2 pb-4 last-of-type:pb-0",
        !milestone.started && "opacity-30",
      )}
    >
      <div
        className={cn(
          "absolute bottom-0 left-3 top-0 z-0 w-0.5 bg-[#E5E7EB] group-last-of-type:hidden",
          milestone.started && "bg-green-600",
        )}
      ></div>

      {milestone.started ? (
        milestone.finished ? (
          <CheckCircleSolid className="z-10 bg-white text-green-600" />
        ) : (
          <CheckCircleOutline className="z-10 bg-white" />
        )
      ) : (
        <CheckCircleOutline className="z-10 bg-white" />
      )}

      <div className="text-sm">
        <div className="font-bold text-[#13171B]">
          {startDate} - {endDate}
        </div>
        <div className="text-[#4F5D6D]">{milestone.description}</div>
      </div>
    </div>
  );
};

export default MilestonesDropdownItem;
